import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { FlowProvider, useFlow } from './../../context/FlowContext';
import AndroidIntro from './AndroidIntro.jsx';
import VisorID from './VisorID';
import InstallOver14 from './InstallOver14';
import InstallUnder14 from './InstallUnder14';
import FinalChecks from './FinalChecks';
import AndroidDesktopPage from './AndroidDesktopPage'; // ⬅️ NEW

const RequireVisorCreated = ({ children }) => {
  const { created } = useFlow();
  const loc = useLocation();
  if (!created) return <Navigate to="visor-id" replace state={{ from: loc }} />;
  return <>{children}</>;
};

const isAndroidDevice = () => {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  return /Android/i.test(ua);
};


// ++++ This allows forcing the Android flow even on desktop, for testing purposes ++++
const isForceAndroidMode = () => {
  const envForce = process.env.REACT_APP_FORCE_ANDROID_MODE === 'true';
  if (envForce) return true;
  if (typeof window === 'undefined') return false;
  return new URLSearchParams(window.location.search).get('forceAndroid') === '1';
};
// ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++


export default function InstallRouter() {
  const onAndroid = isAndroidDevice();// || isForceAndroidMode(); //   || isForceAndroidMode() allow forcing Android flow on desktop for testing

  if (!onAndroid) {
    return (
      <FlowProvider>
        <AndroidDesktopPage />
      </FlowProvider>
    );
  }

  return (
    <FlowProvider>
      <Routes>
        <Route path="/" element={<AndroidIntro />} />
        <Route path="visor-id" element={<VisorID />} />
        <Route path="instover14" element={<InstallOver14 />} />
        <Route path="inunder14" element={<InstallUnder14 />} />
        <Route
          path="final-checks"
          element={
            <RequireVisorCreated>
              <FinalChecks />
            </RequireVisorCreated>
          }
        />
        <Route path="*" element={<Navigate to="." replace />} />
      </Routes>
    </FlowProvider>
  );
}
